import { render } from "./AdminNewProperty.vue?vue&type=template&id=273ab83c"
import script from "./AdminNewProperty.vue?vue&type=script&lang=js"
export * from "./AdminNewProperty.vue?vue&type=script&lang=js"

import "./AdminNewProperty.vue?vue&type=style&index=0&id=273ab83c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__